import { deleteChatDevicesDeviceId } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

/**
 * Plain request (not a hook): called from the logout saga, where the Stream client may already be
 * gone. The API unregisters the push token (APNs/FCM) from Stream for EVERY persona of the caller, so it
 * works whichever persona the device ended up under. Idempotent server-side.
 */
export const removeChatPushDeviceRequest = processResponseWithApiProblemDetails(
  (deviceId: string) => deleteChatDevicesDeviceId(deviceId),
);
